import { useTranslation,  withTranslation } from "react-i18next";
import UserInfo from "./UserInfo";
import { useEffect, useState } from "react";
import { FilterIcon } from "../common/Icons";
import AnnoucementItem from "./AnnoucementItem";
import DateFilter from "../common/DateFilter";
import {
  useGetNoticeBoardDataWithPaginationQuery,
  useReadNoticeBoardDetailMutation,
} from "../../app/services/notice-board";
import {
  generateYear,
  useGetCategoryAllListQuery,
} from "../../app/services/category";
import { CircularProgress } from "@mui/material";
export interface INoticeBoard {}
const years: Number[] = generateYear();
const NoticeBoard = (props: any) => {
  const {t}=useTranslation();
  const [noticesData, setNoticesData] = useState<any>([]);
  const [hasMore, setHasMore] = useState(true);
  const [categoriesData, setCategories] = useState<any>([]);
  const [filter, setFilter] = useState<string>("");
  const [filterYear, setFilterYear] = useState<string>("");
  const [filterMonth, setFilterMonth] = useState<string>("");
  const { data: categories } = useGetCategoryAllListQuery();
  const [showDot, setShowDot] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const { data: notices, isLoading, isFetching,error } = useGetNoticeBoardDataWithPaginationQuery(
    {
      category: filter,
      year: filterYear,
      month: filterMonth,
      page: page,
      limit:10
    }
  );
  const [readNoticeBoard] = useReadNoticeBoardDetailMutation();
  useEffect(() => {
    if (notices) {
      const isRead=notices?.noticeBoardList?.data?.find(x=>x.readStatus==false);
      if(isRead){
        setShowDot(true);
      }else{
        setShowDot(false);
      }
      setNoticesData(notices?.noticeBoardList?.data);
    }
  }, [notices]);
  useEffect(() => {
    setNoticesData([]);
    setPage(1);
    setHasMore(true);
  }, [filter, filterYear,filterMonth]);
  useEffect(() => {
    if (notices) {
      setNoticesData((prev:any) =>
        page === 1 ? notices.noticeBoardList?.data : [...prev, ...notices.noticeBoardList?.data]
      );
      const currentTotal = page === 1
        ? notices.noticeBoardList?.data?.length || 0
        : noticesData.length + (notices.noticeBoardList?.data?.length || 0);
      if (currentTotal >= notices.noticeBoardList?.total) {
        setHasMore(false);
      }
    }
  }, [notices]);
  useEffect(() => {
    if (categories) {
      setCategories([{ id: 0, name: t('all') }, ...categories?.categoryList]);
    }
  }, [categories]);
  const filterByDate = (desc: boolean) => {
    let sortedEvents = [...noticesData].sort(
      (a, b) =>
        new Date(a.expired_at).getTime() - new Date(b.expired_at).getTime()
    );
    if (desc) {
      sortedEvents = [...noticesData].sort(
        (a, b) =>
          new Date(b.expired_at).getTime() - new Date(a.expired_at).getTime()
      );
    }
    setNoticesData([...sortedEvents]);
  };
  const readNoticeBoardDetail = (id: number) => {
    readNoticeBoard(id).then((res: any) => {});
  };
  const loadMore = () => {
    if (!isFetching && hasMore) {
      setPage((prev) => prev + 1);
    }
  };
  return (
    <div className="px-5">
      <DateFilter
        filter={filter}
        setFilter={setFilter}
        years={years}
        setFilterYear={setFilterYear}
        filterYear={filterYear}
        filterData={categoriesData}
        filterByDate={filterByDate}
        filterMonth={filterMonth}
        setFilterMonth={setFilterMonth}
        showMonth={true}
        t={t}
      />
      {isLoading ? (
        <CircularProgress />
      ) : (
        <div className="mt-4">
          <ul className="max-h-[55vh] overflow-auto mb-[65px]">
          {isLoading===false && isFetching===false && noticesData?.length<=0 && <p className="text-body-sm font-normal text-sat_darkblackv2">{t('no_more_notice')}</p>}
            {noticesData?.map((anno: any, key: number) => {
              return (
                <li key={key}>
                  <AnnoucementItem
                    link={"/profile/notice_board/" + (key + 1)}
                    date={anno.published_at}
                    is_download={anno.is_download}
                    time={""}
                    title={anno.name}
                    description={anno.description}
                    tags={anno.categories}
                    url={anno.file_url}
                    filesize={anno.file_size}
                    readStatus={anno.readStatus}
                    id={anno.id}
                    isFavourite={anno.isFavourite}
                    readNoticeBoardDetail={() => 1}
                  />
                </li>
              );
            })}
             {error && <p>Error loading data</p>}
             {hasMore && (
            <button onClick={loadMore} disabled={isFetching} className="underline underline-offset-2 text-body-sm font-normal text-sat_darkblackv2">
              {isFetching ? <CircularProgress/> : t('view_more')}
            </button>
          )}
          </ul>
        </div>
      )}
    </div>
  );
};
export default withTranslation('common')(NoticeBoard);
